// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__6Z7a8","fullScreen":"Loader_fullScreen__6Dnbm","spinner":"Loader_spinner__jZedo","spin":"Loader_spin__L7yww"};